import request from '@/router/axios';
/**
 * 获取已配置默认租付类型的产品列表(分页)
 * @param { Object } data 
 * @param { Number } data.current
 * @param { Number } data.size
 * @param { type } data.type 租付类型
 * @param { productId } data.productId 产品id
 * @returns 
 */
export const getList = (data) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductDefaultType/page',
        method: 'post',
        data: {
            ...data
        }
    })
}

/**
 * 获取所有配置了默认租付类型的产品列表(不分页)
 * @param { null } data 不需要传值
 * @returns 
 */
export const getListAll = (data) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductDefaultType/list',
        method: 'post',
        data: {
            ...data
        }
    })
}

/**
 * 删除默认租付类型
 * @param { Number | String } ids 默认租付类型id
 * @returns 
 */
export const remove = (ids) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductDefaultType/remove',
        method: 'post',
        params: {
            ids
        }
    })
}

/**
 * 新增默认租付类型
 * @param { Object } row 
 * @param { Number | String } row.productId 产品id
 * @param { Number | String } row.productValue 产品值
 * @param { Number | String } row.type 租付类型
 * @returns 
 */
export const add = (row) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductDefaultType/submit',
        method: 'post',
        data: row
    })
}

/**
 * 修改默认租付类型
 * @param { Object } row 
 * @param { Number | String } row.id 默认租付类型id
 * @param { Number | String } row.productId 产品id
 * @param { Number | String } row.productValue 产品值
 * @param { Number | String } row.type 租付类型
 * @returns 
 */
export const update = (row) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductDefaultType/submit',
        method: 'post',
        data: row
    })
}

/**
 * 获取所有未配置默认租付类型的产品列表(不分页)
 * @param { null } data 不需要传值
 * @returns 
 */
export const getProductList = (data) => {
    return request({
        url: '/api/blade-loanProductManagement/loanProductDefaultType/getProductList',
        method: 'post',
        data: {
            ...data
        }
    })
}